module.exports = __webpack_public_path__ + "static/img/badge-multi-active.2e1cd0f.svg";